import axiosIns from '@/plugins/axios'

export default {
  getKitchenPrinters() {
    return axiosIns.get('/waiter/kitchen_printers')
  },
}
